import React from "react"

import Translate from "../../../../app/scripts/components/Translate"

const Loading = () => (
  <div className="spLoader _loading">
    <Translate tKey="common.loading" options={{ process: "firstCharUp" }} />
  </div>
)

export default Loading
